import { lighten, size } from "polished";
import styled, { css } from "styled-components";
import media from "styled-media-query";

import { themes } from "styles";

import { FeatherIcons, Loader as LoaderComponent } from "../Icons";

import { IButtonProps } from "./interfaces";

export const Loader = styled(LoaderComponent).attrs(() => ({
  switch: true,
}))`
  margin-right: 8px;
`;

export const Icon = styled(FeatherIcons)`
  ${size("12px")}

  margin-right: 8px;

  color: #f6f7fb;
  transition: 0.3s;
  pointer-events: none;

  ${media.greaterThan("huge")`
    ${size("18px")}
  `}
`;

export const Container = styled.button<
  Pick<IButtonProps, "kind" | "size" | "isDisabled" | "variant"> & {
    disabled?: boolean;
  }
>`
  all: unset;

  position: relative;

  padding: 14px 20px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  border-radius: 8px;
  box-sizing: border-box;
  transition: background-color 0.3s;

  color: #fff;
  -webkit-text-fill-color: #fff;

  text-align: center;
  border: 1px solid transparent;
  font: bold 11px ${themes.fonts.title};

  background-color: ${(props) => themes.palletes[props.variant]};

  &:hover {
    transition: background-color 0.3s;
    background-color: ${(props) =>
      lighten(0.06, themes.palletes[props.variant])};
  }

  &:active {
    transform: scale(0.98);
    transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  }

  ${media.greaterThan("large")`
    padding: 16px 24px;

  `}

  ${media.greaterThan("huge")`
    padding: 20px 32px;

    font-size: 14px;
    border-radius: 12px;
  `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.6;

      cursor: not-allowed;
    `}

  ${({ size }) =>
    size &&
    {
      block: css`
        width: 100%;

        display: flex;

        ${Icon} {
          position: absolute;
          top: 50%;
          right: 16px;
          transform: translateY(-50%);

          margin-right: 0;
        }

        ${Loader} {
          position: absolute;
          top: 35%;
          right: 16px;

          margin-right: 0;
        }
      `,

      small: css`
        padding: 8px 10px;

        font-size: 7px;
        border-radius: 8px;

        ${media.greaterThan("large")`
          padding: 8px 14px;

          font-size: 9px;
        `}

        ${media.greaterThan("huge")`
          padding: 12px 22px;

          font-size: 10px;
        `}
      `,
    }[size]}
    
  ${(props) =>
    props.kind &&
    css`
      ${themes.button.kinds}

      &:hover {
        color: #fff;
        -webkit-text-fill-color: #fff;
      }

      ${Icon} {
        color: inherit;
      }
    `}
`;
